import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  UniqueBnDev,
  SessionDistribution,
  UniqueBookings,
  UniqueBought,
  TrafficSource
} from './components'
import { AIDrawer } from '../AIAgent'
import { selectRecommendations, selectDrawerOpen, setDrawerOpen, selectAgentEnabled } from '../AIAgent/agentSlice'
import { FaRegLightbulb } from 'react-icons/fa'
import { HiSparkles } from 'react-icons/hi2'

const Main = () => {
  const dispatch = useDispatch();
  const drawerOpen = useSelector(selectDrawerOpen);
  const recommendations = useSelector(selectRecommendations);
  const agentEnabled = useSelector(selectAgentEnabled);

  return (
    // do not remove flex-grow, it is used to fill the remaining space
    <div className="flex-grow" >
      <div className="my-3 p-3 w-full">

        {/* ─── Floating AI Insights pill ─── */}
        {agentEnabled && (
          <div className="flex justify-end mb-4">
            <button
              onClick={() => dispatch(setDrawerOpen(true))}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full border border-indigo-200 hover:border-indigo-400 bg-white hover:bg-indigo-50 shadow-sm hover:shadow-md transition-all duration-300"
              style={{
                background: 'linear-gradient(135deg, rgba(255,255,255,0.95), rgba(238,242,255,0.9))',
              }}
            >
              <span className="w-6 h-6 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-sm">
                <HiSparkles className="text-white text-xs" />
              </span>
              <span className="text-xs font-semibold text-slate-700 group-hover:text-indigo-700 transition-colors">
                AI Insights
              </span>
              {recommendations.length > 0 && (
                <span className="min-w-[20px] h-5 flex items-center justify-center px-1.5 rounded-full bg-indigo-600 text-white text-[10px] font-bold shadow-sm">
                  {recommendations.length}
                </span>
              )}
            </button>
          </div>
        )}

        {/* ─── Dashboard cards — now full width ─── */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <UniqueBnDev display={"dashboard"} />
          <SessionDistribution display={"dashboard"} />
          <UniqueBookings />
          <UniqueBought />
          <div className="lg:col-span-2">
            <TrafficSource />
          </div>
        </div>
      </div>

      {/* ─── AI Drawer (overlay, not in grid) ─── */}
      {agentEnabled && (
        <AIDrawer isOpen={drawerOpen} onClose={() => dispatch(setDrawerOpen(false))} />
      )}
    </div>
  );
};

export default Main;
